export var buttonActionTypes = {
  LINK: 'link',
  DISMISS: 'dismiss'
};